import React from 'react';
import { InfoTooltip as RootInfoTooltip } from '@dashboard/components/Tooltip';

function Container({ children }) {
  return (
    <div className="bg-white dark:bg-background rounded border border-gray-200 dark:border-border p-4 flex flex-col gap-y-1 justify-start">
      {children}
    </div>
  );
}

function Icon({ icon }) {
  const IconComponent = icon;

  return (
    <div className="flex items-center justify-start mr-auto mb-2">
      <IconComponent className="w-4 h-4 text-muted-foreground" />
    </div>
  );
}

function Header({ children }) {
  return <div className="flex items-center">{children}</div>;
}

function Title({ children }) {
  return (
    <div className="text-sm text-gray-500 dark:text-muted-foreground font-medium">{children}</div>
  );
}

function InfoTooltip({ children }) {
  return (
    <div className="relative">
      <RootInfoTooltip>{children}</RootInfoTooltip>
    </div>
  );
}

function Value({ children }) {
  return <div className="text-lg font-medium leading-5">{children}</div>;
}

export { Container, Icon, Header, Title, InfoTooltip, Value };
